import {
    GelBoxLayout,
    GelContainerLite,
    GelIcon,
    GelCollapsible,
    GelLabel,
    GelParagraph
} from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import React, { useState, useContext, useRef, useEffect } from "react";
import { GelScreenDetectorContext } from "@tal-gel/components";
import { AdobeClickType } from "../../constants/constants";
import { AdobeAnalytics } from "../analytics/adobe-analytics";
import { useCookies } from "react-cookie";

interface AccordionProps {
    title: string;
    body: string;
    selectedSubSection: number;
    selectedQuestion?: number;
    isFromHomePage?: boolean;
    style?: React.CSSProperties; // Optional style prop
}

const Accordion = (props: AccordionProps) => {
    const { global: { themeColorBorderDefault, sizeBaseUnit, themeColorBackgroundSuccess } } = getGelTokens()

    const [isExpanded, setIsExpanded] = useState(false);
    const { screen, isXsScreen } = useContext(GelScreenDetectorContext) as GelScreenDetectorContext;
    const [{ tpid }] = useCookies(["tpid"])

    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (props.isFromHomePage && props.selectedSubSection == 0 && props.selectedQuestion == 0 && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
            setIsExpanded(true);
        }

    }, []);

    const toggleAccordion = () => {

        AdobeAnalytics.PushClickEvent(tpid, props.title, AdobeClickType.FAQ)
        setIsExpanded(!isExpanded);
    };

    return (
        <div ref={ref} style={{ ...props.style }}>
            <GelContainerLite
                style={{
                    borderTop: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                    borderLeft: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                    borderRight: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                    cursor: "pointer",
                    padding: '0px'
                }}
                onClick={toggleAccordion}
            >
                <GelBoxLayout
                    space={!isXsScreen(screen) ? [7, 0.5, 0.04] : [1, 0.01, 0.05]}
                    gutter={sizeBaseUnit}
                    style={{
                        borderBottom: isExpanded ? `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}` : "",
                        padding: sizeBaseUnit * 4,
                    }}
                >
                    <GelLabel large >
                        {props.title}
                    </GelLabel>
                    <GelIcon
                        name={isExpanded ? "ChevronUp" : "ChevronDown"}
                        color={themeColorBackgroundSuccess}
                        width="20px"
                        height="20px"
                    />
                </GelBoxLayout>
            </GelContainerLite>
            <GelContainerLite
                style={{
                    borderBottom: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                    borderLeft: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                    borderRight: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                }}
            >
                <GelCollapsible open={isExpanded}>
                    <GelContainerLite style={{ padding: '8px 0px' }}>
                        <GelParagraph
                            style={{
                                fontWeight: '400px',
                                color: `#666666`
                            }}
                        >
                            <div dangerouslySetInnerHTML={{ __html: props.body }} />
                        </GelParagraph>
                    </GelContainerLite>
                </GelCollapsible>
            </GelContainerLite>
        </div>
    );
};

export default Accordion;
